import { doc, getDoc, setDoc, updateDoc, Timestamp } from 'firebase/firestore';
import { db } from './firebase';
import { UserProfile } from '../types/types';

const USERS_COLLECTION = 'users';

export const createUserProfile = async (uid: string, data: Partial<UserProfile>): Promise<void> => {
    try {
        const userRef = doc(db, USERS_COLLECTION, uid);
        const userProfile: UserProfile = {
            uid,
            email: data.email || '',
            displayName: data.displayName || '',
            role: data.role || 'viewer',
            createdAt: Timestamp.now(),
            updatedAt: Timestamp.now(),
            ...data
        };

        await setDoc(userRef, userProfile);
        console.log('User profile created for:', uid);
    } catch (error) {
        console.error('Error creating user profile:', error);
        throw error;
    }
};

export const getUserProfile = async (uid: string): Promise<UserProfile | null> => {
    try {
        const userRef = doc(db, USERS_COLLECTION, uid);
        const docSnap = await getDoc(userRef);

        if (docSnap.exists()) {
            return docSnap.data() as UserProfile;
        } else {
            console.log('No user profile found for:', uid);
            return null;
        }
    } catch (error) {
        console.error('Error getting user profile:', error);
        throw error;
    }
};

export const updateUserProfile = async (uid: string, data: Partial<UserProfile>): Promise<void> => {
    try {
        const userRef = doc(db, USERS_COLLECTION, uid);
        await updateDoc(userRef, {
            ...data,
            updatedAt: Timestamp.now()
        });
        console.log('User profile updated for:', uid);
    } catch (error) {
        console.error('Error updating user profile:', error);
        throw error;
    }
};
